<template>
    <div class="row">
        <div class="col-12">
            <small class="d-block mb-1 text-center">
                GSM numarasını doğrulamak için SMS ile gönderilen 6 haneli kodu giriniz.
            </small>
            <v-pin-code v-model="value.code"></v-pin-code>
        </div>
    </div>
</template>

<script>
import VPinCode from '@/components/VPinCode.vue'
export default{
    components:{
        VPinCode
    },
    props:{
        value:Object
    }
}
</script>